<div class="printing-home">
  <app-table
    [columns]="columns"
    [data]="printingState.data()"
    [config]="config"
    [pagination]="pagination"
    (sortChange)="onSortChange($event)"
    (pageChange)="onPageChange($event)"
    (pageSizeChange)="onPageSizeChange($event)"
    (actionClick)="onActionClick($event)"
    (searchChange)="onSearchChange($event)"
    (filterChange)="onFilterChange($event)"
    (dateRangeChange)="onDateRangeChange($event)"></app-table>
</div>
